const countries = [
  ['Afghanistan', 'AF', 'AFN'], ['Albania', 'AL', 'ALL'], ['Algeria', 'DZ', 'DZD'], ['Argentina', 'AR', 'ARS'],
  ['Australia', 'AU', 'AUD'], ['Austria', 'AT', 'EUR'], ['Azerbaijan', 'AZ', 'AZN'], ['Bahamas', 'BS', 'BSD'],
  ['Bahrain', 'BH', 'BHD'], ['Bangladesh', 'BD', 'BDT'], ['Belgium', 'BE', 'EUR'], ['Brazil', 'BR', 'BRL'],
  ['Brunei', 'BN', 'BND'], ['Bulgaria', 'BG', 'BGN'], ['Cambodia', 'KH', 'KHR'], ['Canada', 'CA', 'CAD'],
  ['Chile', 'CL', 'CLP'], ['China', 'CN', 'CNY'], ['Colombia', 'CO', 'COP'], ['Croatia', 'HR', 'EUR'],
  ['Cyprus', 'CY', 'EUR'], ['Czechia', 'CZ', 'CZK'], ['Denmark', 'DK', 'DKK'], ['Egypt', 'EG', 'EGP'],
  ['Estonia', 'EE', 'EUR'], ['Ethiopia', 'ET', 'ETB'], ['Finland', 'FI', 'EUR'], ['France', 'FR', 'EUR'],
  ['Georgia', 'GE', 'GEL'], ['Germany', 'DE', 'EUR'], ['Ghana', 'GH', 'GHS'], ['Greece', 'GR', 'EUR'],
  ['Hong Kong', 'HK', 'HKD'], ['Hungary', 'HU', 'HUF'], ['Iceland', 'IS', 'ISK'], ['India', 'IN', 'INR'],
  ['Indonesia', 'ID', 'IDR'], ['Iran', 'IR', 'IRR'], ['Iraq', 'IQ', 'IQD'], ['Ireland', 'IE', 'EUR'],
  ['Israel', 'IL', 'ILS'], ['Italy', 'IT', 'EUR'], ['Japan', 'JP', 'JPY'], ['Jordan', 'JO', 'JOD'],
  ['Kazakhstan', 'KZ', 'KZT'], ['Kenya', 'KE', 'KES'], ['Kuwait', 'KW', 'KWD'], ['Laos', 'LA', 'LAK'],
  ['Latvia', 'LV', 'EUR'], ['Lebanon', 'LB', 'LBP'], ['Lithuania', 'LT', 'EUR'], ['Luxembourg', 'LU', 'EUR'],
  ['Malaysia', 'MY', 'MYR'], ['Maldives', 'MV', 'MVR'], ['Malta', 'MT', 'EUR'], ['Mexico', 'MX', 'MXN'],
  ['Morocco', 'MA', 'MAD'], ['Myanmar', 'MM', 'MMK'], ['Nepal', 'NP', 'NPR'], ['Netherlands', 'NL', 'EUR'],
  ['New Zealand', 'NZ', 'NZD'], ['Nigeria', 'NG', 'NGN'], ['Norway', 'NO', 'NOK'], ['Oman', 'OM', 'OMR'],
  ['Pakistan', 'PK', 'PKR'], ['Philippines', 'PH', 'PHP'], ['Poland', 'PL', 'PLN'], ['Portugal', 'PT', 'EUR'],
  ['Qatar', 'QA', 'QAR'], ['Romania', 'RO', 'RON'], ['Russia', 'RU', 'RUB'], ['Saudi Arabia', 'SA', 'SAR'],
  ['Serbia', 'RS', 'RSD'], ['Singapore', 'SG', 'SGD'], ['Slovakia', 'SK', 'EUR'], ['Slovenia', 'SI', 'EUR'],
  ['South Africa', 'ZA', 'ZAR'], ['South Korea', 'KR', 'KRW'], ['Spain', 'ES', 'EUR'], ['Sri Lanka', 'LK', 'LKR'],
  ['Sweden', 'SE', 'SEK'], ['Switzerland', 'CH', 'CHF'], ['Taiwan', 'TW', 'TWD'], ['Tanzania', 'TZ', 'TZS'],
  ['Thailand', 'TH', 'THB'], ['Turkey', 'TR', 'TRY'], ['Ukraine', 'UA', 'UAH'], ['United Arab Emirates', 'AE', 'AED'],
  ['United Kingdom', 'GB', 'GBP'], ['United States', 'US', 'USD'], ['Uzbekistan', 'UZ', 'UZS'], ['Vietnam', 'VN', 'VND'],
]

export const countryOptions = countries.map(([name, code, currency]) => ({ name, code, currency }))
export const countryMetaByName = Object.fromEntries(countryOptions.map(country => [country.name.toLowerCase(), country]))

export function currencySymbol(currency) {
  try {
    const parts = new Intl.NumberFormat('en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).formatToParts(0)
    return parts.find(part => part.type === 'currency')?.value || currency
  } catch {
    return currency || ''
  }
}
